import { FC } from "react";
import {
  ConditionIcon,
  IconBox,
  RaffleConditions,
} from "entities/wheel-raffle";
import type { Raffle } from "entities/wheel-raffle";

import styles from "./RaffleDetailPage.module.css";

export const ConditionsSection: FC<{ raffle: Raffle }> = ({ raffle }) => (
  <>
    <div className={styles.sectionHeader}>
      <IconBox size="lg">
        <ConditionIcon name="clipboard" size={26} />
      </IconBox>
      <div>
        <h2 className={styles.panelTitle}>Conditions</h2>
        <p className={styles.subtitle}>
          Raffle settings and participation requirements
        </p>
      </div>
    </div>
    <RaffleConditions raffle={raffle} />
  </>
);
